import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'

import PendingNavDataLoader from './components/pendingNavDataLoader'
import routes from '../common/routes'

const App = ({ store }) => (
  <Provider store={store} >
    <BrowserRouter>
      <PendingNavDataLoader store={store} routes={routes}>
        {renderRoutes(routes)}
      </PendingNavDataLoader>
    </BrowserRouter>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./client/app.js